var map = {
	"./billing/besplatniy.png": "bc77",
	"./billing/pro.png": "4e76",
	"./billing/scriptolog.png": "360a",
	"./integration/amo/in-work1.gif": "75a1",
	"./integration/amo/in-work2.jpg": "6611",
	"./integration/amo/install2.gif": "ab86",
	"./integration/amo/logo.png": "e5b7",
	"./integration/amo/market.jpg": "c02e",
	"./integration/amo/widget.jpg": "e5cc",
	"./integration/bitrix/in-work1.gif": "679e",
	"./integration/bitrix/in-work2.png": "cd66",
	"./integration/bitrix/install1.gif": "2b38",
	"./integration/bitrix/logo.png": "af13",
	"./integration/bitrix/market.png": "2610",
	"./integration/bitrix/widget.png": "a328",
	"./integration/chrom/in-work1.gif": "fa75",
	"./integration/chrom/in-work2.jpg": "a387",
	"./integration/chrom/install1.gif": "1995",
	"./integration/chrom/logo.png": "9557",
	"./integration/chrom/market.jpg": "591f",
	"./integration/chrom/widget.jpg": "28fc",
	"./integration/video-placeholder.png": "1876"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e1";